var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.47,12c-1.64,0-3.21,0-4.78,0a1.33,1.33,0,0,0-1.43.75.63.63,0,0,1-1.12,0A1.33,1.33,0,0,0,5.71,12c-1.57,0-3.14,0-4.78,0V2c2.25.28,4.75-.37,6.77.59A5.28,5.28,0,0,1,10,2C11.49,2,13,2,14.47,2Zm-7.3-1c0-2.24,0-4.57,0-6.89a1,1,0,0,0-1-1c-1.39,0-2.78,0-4.2,0V11Zm1.06,0h5.21V3.05c-1.43,0-2.82,0-4.21,0a1,1,0,0,0-1,1C8.22,6.4,8.23,8.73,8.23,10.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.19,7.46,2.64,5.89l.7-.59.9.77L5.8,4.59l.64.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,9.82v-1H6.08l0,1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.06,6l-.8-.86.67-.73.91.79.9-.76.72.65L11.67,6l.76.89-.65.72-.92-.79-.9.77L9.25,7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.33,8.87h3.06v.94H9.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.8c70411697b3a46319c3a399625e595e.svg";
export { ForwardRef as ReactComponent };